<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Subject History
      </h2>
      <p class="tw-italic tw-text-gray-700">
        A list of ALL forms submitted for a Subject. Click on form titles for more details.
      </p>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col>
          <b-form-input
            label="Subject ID"
            placeholder="Start typing subject id to filter, or double click to get list."
            v-model="subjectId"
            list="subject-id-list"
            size="lg"
            @keypress.enter="search()"
            @click:append="search()"
          ></b-form-input>

          <datalist id="subject-id-list">
            <option v-for="sId in subjectIDs" :key="sId">{{ sId }}</option>
          </datalist>
        </b-col>
      </b-row>
    </b-container>
    <hr />

  <SubjectHistoryForms :forms="forms" />

  </div>
</template>

<script>
/**
 * Search a subject id and get the forms submitted for this subject.
 * Show them in a timeline. When clicked, show the details in an inverted table in a modal.
 */

import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  components: {},
  props: {},
  data: function() {
    return {
      subjectId: null,
      subjectIDs: [],
      modal_title: "Details",
      modal_received_on: "",
      modal_items: null,
      forms: []
    };
  },
  created: function() {
    this.get();
  },
  mounted: function() {
    if (this.$route.query.subjectId) {
      this.subjectId = this.$route.query.subjectId;
      this.search();
    }
  },
  watch: {},
  methods: {
    get: function() {
      const that = this;
      HTTP.get("/kenya/subject/ids")
        .then(response => {
          that.subjectIDs = _.uniq(response.data);
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },
    search: function() {
      const that = this;
      HTTP.get("/kenya/subject/forms?subject_id=" + that.subjectId)
        .then(response => {
          let forms = [];
          _.each(response.data, function(def) {
            _.each(def.items, function(form) {
              forms.push({
                name: def.name,
                data: form
              });
            });
          });

          that.forms = _.orderBy(forms, ["data.received_on"], ["asc"]);
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
